import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/web/purchase-notice";
const purchaseApi = {
  // 公示公告 列表
  page(params) {
    return request({
      url: `${baseUrl}/page`,
      method: "GET",
      params
    });
  },
  // 公告基础信息
  baseInfo(params) {
    return request({
      url: `${baseUrl}/get`,
      method: "GET",
      params: params
    });
  },
  // 详细内容
  detail(params) {
    return request({
      url: `${baseUrl}/getNoticeContent`,
      method: "GET",
      params
    });
  },
  // 近期开标
  pageForOpenTender(params = { pageNo: 1, pageSize: 9 }) {
    return request({
      url: `${baseUrl}/pageForOpenTender`,
      method: "GET",
      params
    });
  }
};
export default purchaseApi;
